module.exports = __webpack_public_path__ + "img/Ensuring_Market_Stability_During_COVID-19.547f5a99.jpg";